<template>
  <div class="discovery-search-header">
    <div class="discovery-search-header-left">
      <button class="discovery-mode-button"
        :class="{ active: displayMode === 'masonry' }"
        @click="switchDisplayMode('masonry')"
        @keyup="switchDisplayMode('masonry')"
      >
        <icon-masonry class="discovery-display-icon" />
        <span class="discovery-display-label">Grid View</span>
      </button>
      <button class="discovery-mode-button"
        :class="{ active: displayMode === 'rows' }"
        @click="switchDisplayMode('rows')"
        @keyup="switchDisplayMode('rows')"
      >
        <icon-list class="discovery-display-icon" />
        <span class="discovery-display-label">List View</span>
      </button>
    </div>

    <div v-if="pages > 1" class="discovery-pager" ref="display">
      <button v-if="displayPrev" class="discovery-pager-prev" @click="setPage('prev')">
        Back
      </button>
      <div class="discovery-search-summary">
        Showing {{ start }} - {{ end }} of {{ search.data.TotalRecordsFound }}
      </div>
      <button v-if="displayNext" class="discovery-pager-next" @click="setPage('next')">
        Next
      </button>
    </div>

    <div class="discovery-search-header-right">
      <span class="discovery-search-sort-label">Sort by: </span>
      <select class="discovery-search-sort" v-model="sort" @change="switchSortMode">
        <option value="RELEVANCE">Top Matches</option>
        <option value="MP/sort.descending">Most Popular</option>
        <option value="PD/sort.descending">Newest</option>
      </select>
    </div>
  </div>
</template>

<script>
import IconMasonry from '@/components/svg/IconMasonry.vue';
import IconList from '@/components/svg/IconList.vue';

export default {
  name: 'SearchHeader',
  components: {
    IconMasonry,
    IconList,
  },
  props: {
    displayMode: String,
    search: Object,
  },
  data() {
    return {
      sort: 'RELEVANCE',
    };
  },
  computed: {
    pages() {
      return Math.ceil(this.search.data.TotalRecordsFound / this.search.num);
    },
    // Get range of search results
    start() {
      return this.search.page * this.search.num - this.search.num + 1;
    },
    end() {
      return Math.min(this.search.page * this.search.num, this.search.data.TotalRecordsFound);
    },
    displayPrev() {
      return this.search.page > 1;
    },
    displayNext() {
      return this.search.page < this.pages;
    },
  },
  mounted() {
    // Set initial sort value
    if (this.search.sort) this.sort = this.search.sort;
  },
  methods: {
    switchDisplayMode(mode) {
      this.$emit('switchDisplayMode', mode);
    },
    switchSortMode() {
      this.$emit('switchSortMode', this.sort);
    },
    setPage(page) {
      if (page === 'prev') this.$emit('setPage', Math.max(1, this.search.page - 1));
      else if (page === 'next') this.$emit('setPage', Math.min(this.search.page + 1, this.pages));
      else this.$emit('setPage', page);
    },
  },
};
</script>

<style lang="less">
.discovery-search-header {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.discovery-search-header-right,
.discovery-search-header-left {
  display: flex;
  align-items: center;
}
.discovery-search-sort {
  margin-left: 0.5rem;
}
.discovery-mode-button {
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
}
.discovery-display-label {
  padding-left: 0.5rem;
}
.discovery-display-icon {
  height: 24px;
  width: 24px;
  display: block;
}

.discovery-pager {
  display: flex;
  justify-content: center;
  align-items: stretch;
}
.discovery-pager > * {
  display: grid;
  place-items: center;
}
.discovery-pager button {
  min-width: 5rem;
  cursor: pointer;
}
.discovery-search-summary {
  padding: 0 2rem;
}
</style>
